<div class="content-modal">
   <div class="container-modal" style="min-width: 730px;">
      <div class="mt-2 text-xs">
         <div style="float: right">
            <button (click)="refreshData()">{{ 'common.reload' |
               translate }}</button>
         </div>
         <div>
            <span class="inline-block col-2 font-bold text-right p-0">{{ 'common.environment' | translate }}:</span> {{envName}}<br>
            <span class="inline-block col-2 font-bold text-right p-0">{{ 'common.client' | translate }}:</span> {{clientVersion}}<br>
            <span class="inline-block col-2 font-bold text-right p-0">{{ 'common.server' | translate }}:</span> {{serverVersion}}<br>
            <span class="inline-block col-2 font-bold text-right p-0">{{ 'devTools.serverName' | translate }}:</span> {{serverName}}<br>
            <span class="inline-block col-2 font-bold text-right p-0">{{ 'devTools.userNameId' | translate }}:</span> {{userName}} ({{personId}})<br>
            <span class="inline-block col-2 font-bold text-right p-0">{{ 'devTools.sessionId' | translate }}:</span> {{sessionId}}<br>
            <span class="inline-block col-2 font-bold text-right p-0">{{ 'devTools.clockDiscrepancy' | translate }}:</span> {{clockDiscrepancy}}ms<br>
         </div>
         <div class="mt-1">
            <p-table [value]="accessibleScreens"
                     [scrollable]="true"
                     scrollHeight="8rem"
                     class="accessibleTable">
               <ng-template pTemplate="header">
                  <tr><th scope="col"><strong>{{'devTools.screens'| translate}}</strong></th></tr>
               </ng-template>
               <ng-template pTemplate="body" let-item>
                  <tr><td>{{item}}</td></tr>
               </ng-template>
            </p-table>
            <p-table [value]="accessibleRoles"
                     [scrollable]="true"
                     scrollHeight="8rem"
                     class="accessibleTable">
               <ng-template pTemplate="header">
                  <tr><th scope="col"><strong>{{'devTools.roles'| translate}}</strong></th></tr>
               </ng-template>
               <ng-template pTemplate="body" let-item>
                  <tr><td>{{item}}</td></tr>
               </ng-template>
            </p-table>
         </div>
         <div class="mt-1">
            <label for="dev-notify-text" class="col-2 font-bold text-right p-0">{{ 'devTools.notifyTest' | translate }}:</label>
            <input id="dev-notify-text" type="text" [(ngModel)]="notifyText" placeholder="Message" maxlength="1000" class="ml-1 w-200">
            <button (click)="testNotification()" class="ml-1">{{ 'devTools.notify' | translate }}</button>
            <input id="dev-with-toast" type="checkbox" [(ngModel)]="withToast"> <label for="dev-with-toast">{{ 'devTools.withToast' | translate }}</label><br>
         </div>
         <div class="mt-1">
            <label for="dev-dialog-text" class="col-2 font-bold text-right p-0">{{ 'devTools.dialogTest' | translate }}:</label>
            <input id="dev-dialog-text" type="text" [(ngModel)]="dialogText" placeholder="Message" maxlength="1000" class="ml-1 w-200">
            <button (click)="testDialog('INFO')" class="ml-1">INFO</button>
            <button (click)="testDialog('ERROR')" class="ml-1">ERROR</button>
            <button (click)="testDialog('EXCEPTION')" class="ml-1">EXCEPTION</button>
            <br>
         </div>
         <div class="mt-1">
            <label for="dev-loader-text" class="col-2 font-bold text-right p-0">{{ 'devTools.loaderTest' | translate }}:</label >
            <input id="dev-loader-text" type="text" [(ngModel)]="loaderText" placeholder="Title" maxlength="1000" class="ml-1 w-200">
            <button (click)="testLoader(100)" class="ml-1">100ms</button>
            <button (click)="testLoader(500)" class="ml-1">500ms</button>
            <button (click)="testLoader(1000)" class="ml-1">1000ms</button>
            <button (click)="testLoader(5000)" class="ml-1">5000ms</button>
            <button (click)="testLoaderMultiple(1000,3,1500)" class="ml-1">Separate</button>
            <button (click)="testLoaderMultiple(2000,10,500)" class="ml-1">Overlapping</button>
         </div>
         <div class="mt-1">
            <span class="inline-block col-2 font-bold text-right p-0">{{ 'devTools.spellDict' | translate }}:</span> {{ spellingNumwords }}
            <button (click)="clearIIRDictionaryCache()" class="ml-1">{{ 'devTools.clearCache' | translate }}</button>
         </div>
         <div class="mt-1">
            <span class="inline-block col-2 font-bold text-right p-0">{{ 'devTools.signalApp' | translate }}:</span>
            <button (click)="testSignalToken(true)" class="ml-1">Generate Token</button>
            <button (click)="testSignalToken(false)" class="ml-1">Generate Token (nocache)</button>
            <button (click)="testSignalQuery()" class="ml-1">Run Sample Query</button>
         </div>
         <div class="mt-1">
            <span class="inline-block col-2 font-bold text-right p-0">{{ 'devTools.llmApp' | translate }}:</span>
            <button (click)="testLlmToken(true)" class="ml-1">Generate Token</button>
            <button (click)="testLlmToken(false)" class="ml-1">Generate Token (nocache)</button>
            <button (click)="testLlmRgcUrl()" class="ml-1">Generate RGC Embed URL</button>
            <button (click)="testLlmRaApi()" class="ml-1">Test RA API Call</button>
         </div>
      </div>
   </div>
</div>
